<template>
  <div>
    <div
      v-if="disableSelectedItemPanel"
      class="changeStyleMain"
      style="left: 0px; top: 0px; display:none;"
    >
      插入编辑器
    </div>
    <div id="mytoolbar" class="mytoolbar"></div>
    <div
      class="tinymce-editor"
      id="editorAndAdvPanel"
      v-loading="isShow"
      element-loading-text="智能原创分析中..."
      element-loading-spinner="el-icon-loading"
    >
      <div style="display: flex;position: relative;" class="input">
        <div style="color: #216bed;position: absolute;top: 18px;right: 74px;font-size: 14px;line-height: 16px;margin-right: 0px;background-color: #e0e6f6;padding: 5px 5px;border-radius: 30px 30px;text-indent: 5px;">
          <a style="color: #216bed;" :href="`https://www.5118.com/titleoptimizer/${getTitle.encodeUnicode()}`" target="_blank">标题助手</a>
        </div>
        <div class="app-course1122">
          <Course name="Editor" />
        </div>
        <el-input
          :title="getTitle"
          v-model="getTitle"
          @click.native="titleChanged"
          placeholder="无标题"
          :maxlength="50"
        ></el-input>
        <div :class="[getTitle.length >= 50 ? 'red' : '']">
          {{ getTitle.length }}/50
        </div>
      </div>
      <div class="hr"></div>
      <div ref="editorDiv">
        <div class="wordsCount">字数 {{ contentCount }}</div>
        <editor
          v-model="myValue"
          :init="init"
          :disabled="disabled"
          @onInit="editorInited"
          @onChange="editorChanged"
          @onClick="onClickItem"
          @onDirty="editorChanged"
          @onKeyUp="editorChanged"
        ></editor>
        <!-- <div style="position: absolute;text-align: left;color:black!important;font-size: 14px;" v-if='dataSource && dataSource.length>0'>
<div class="links" >
      友情链接：
      <a v-for='(item,index) in dataSource' :key="index" :href="item.url" target="_blank" class="link-item">{{item.title}}</a>
    </div>

        </div>
          <div style="position: relative;text-align: center;color:black!important;font-size: 14px;top:20px"><a style="color:black!important" target="_blank" href="https://beian.miit.gov.cn/ ">粤ICP备15002054号</a>  珠海市五一一八科技有限公司 </div> -->
      </div>
      <WycListBtn
        ref="wyclistbtn"
        id="menuBtn"
        :class="[
          !rightShow
            ? contentWidth < 1600
              ? contentWidth < 1400
                ? 'listbutton3'
                : 'listbutton2'
              : 'listbutton'
            : contentWidth < 1400
            ? 'listbutton4'
            : 'listbutton1'
        ]"
      ></WycListBtn>
      <Loading :isShow="isShowLoading"></Loading>

      <div
        class="changeStyleMain"
        :style="{ top: getChangeStyleTop + 'px' }"
        v-if="!disableSelectedItemPanel"
      >
        <el-card :body-style="{ padding: '10px' }" shadow="always">
          <el-row v-if="styleItemAllColors.length > 0">
            <el-col :span="2" class="mr5">
              <span>颜色:</span>
            </el-col>
            <el-col
              :span="2"
              v-for="(color, index) in styleItemAllColors"
              :key="index"
            >
              <div :id="index" @click="pickerClick(index)">
                <el-color-picker
                  v-model="styleItemAllColors[index]"
                  @change="styleItemPickColorChange"
                  @active-change="styleItemPickColorChange"
                  size="mini"
                  :show-alpha="false"
                  color-format="rgb"
                  :id="index"
                ></el-color-picker>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="0">
            <el-col :span="3">
              <el-button
                size="mini"
                round
                class="button"
                :disabled="disableSelectedItemPanel"
                @click="copyStyle"
                >复制</el-button
              >
            </el-col>
            <el-col :span="3">
              <el-button
                size="mini"
                round
                class="button"
                :disabled="disableSelectedItemPanel"
                @click="cutStyle"
                >剪切</el-button
              >
            </el-col>
            <el-col :span="3">
              <el-button
                size="mini"
                round
                class="button"
                :disabled="disableSelectedItemPanel"
                @click="passItemStyle"
                >传递</el-button
              >
            </el-col>
            <el-col :span="4">
              <el-button
                size="mini"
                round
                class="button"
                :disabled="disableSelectedItemPanel"
                @click="insertLineBefore"
                >前空行</el-button
              >
            </el-col>
            <el-col :span="4" class="ml3">
              <el-button
                size="mini"
                round
                class="button"
                :disabled="disableSelectedItemPanel"
                @click="insertLineAfter"
                >后空行</el-button
              >
            </el-col>

            <el-col :span="4" class="ml3">
              <el-button
                size="mini"
                round
                class="button"
                :disabled="disableSelectedItemPanel"
                @click="clearItemStyle"
                >清样式</el-button
              >
            </el-col>
            <el-col :span="2" class="ml3">
              <el-button
                size="mini"
                round
                class="button"
                :disabled="disableSelectedItemPanel"
                @click="deleteStyle"
                >删除</el-button
              >
            </el-col>
          </el-row>
          <el-row>
            <div class="dashed" style="width: 100%"></div>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="3">
              <div class="SliderWords">宽度比</div>
            </el-col>
            <el-col :span="5">
              <!--              <el-slider-->
              <!--                :min="0"-->
              <!--                :max="100"-->
              <!--                v-model="w_h_rate"-->
              <!--                @change="widthChanged"-->
              <!--                :step="1"-->
              <!--                :disabled="disableSelectedItemPanel"-->
              <!--              ></el-slider>-->
              <el-input-number
                class="myWidth"
                v-model="w_h_rate"
                :step="5"
                :min="0"
                :max="100"
                size="mini"
                @change="widthChanged"
                :disabled="disableSelectedItemPanel"
              ></el-input-number>
              <span class="setPercent2">%</span>
            </el-col>
            <!--            <el-col :span="2">-->
            <!--              <input-->
            <!--                :value="w_h_rate"-->
            <!--                @change="inputWidthChanged()"-->
            <!--                type="text"-->
            <!--                class="inputPercent"-->
            <!--                ref="inputw_h_rate"-->
            <!--              />-->
            <!--            </el-col>-->
            <el-col :span="3" class="progressBox" style="padding-left: 22px;">
              <el-button
                type="text"
                class="button"
                :disabled="disableSelectedItemPanel"
                @click="restoreW_h_rate"
              >
                <i class="el-icon-refresh-left"></i>
              </el-button>
            </el-col>
            <el-col :span="4" class="ml10">
              <div class="SliderWords">不透明度</div>
            </el-col>
            <el-col :span="6" style="padding-left: 3px">
              <!--              <el-slider-->
              <!--                :max="1"-->
              <!--                :step="0.01"-->
              <!--                v-model="alpha"-->
              <!--                @change="alphaChanged"-->
              <!--                :disabled="disableSelectedItemPanel"-->
              <!--              ></el-slider>-->
              <el-input-number
                class="myAlpha"
                v-model="alpha"
                :step="10"
                :min="0"
                :max="100"
                size="mini"
                @change="alphaChanged"
                :disabled="disableSelectedItemPanel"
              ></el-input-number>
              <span class="setPercent">%</span>
            </el-col>
            <!--            <el-col :span="2">-->
            <!--              <input-->
            <!--                :value="alpha"-->
            <!--                type="text"-->
            <!--                class="inputPercent"-->
            <!--                @change="inputAlphaChanged"-->
            <!--                ref="inputAlpha"-->
            <!--              />-->
            <!--            </el-col>-->
            <el-col :span="1" class="progressBox">
              <el-button
                type="text"
                class="button"
                :disabled="disableSelectedItemPanel"
                @click="restoreAlpha"
              >
                <i class="el-icon-refresh-left"></i>
              </el-button>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="3">
              <div class="SliderWords">角度</div>
            </el-col>
            <el-col :span="5">
              <el-input-number
                class="myWidth"
                v-model="angle"
                :step="10"
                :min="-180"
                :max="180"
                size="mini"
                @change="angleChanged"
                :disabled="disableSelectedItemPanel"
              ></el-input-number>
            </el-col>
            <el-col :span="3" class="progressBox" style="padding-left: 22px;">
              <el-button
                type="text"
                class="button"
                :disabled="disableSelectedItemPanel"
                @click="restoreAngle"
              >
                <i class="el-icon-refresh-left"></i>
              </el-button>
            </el-col>
          </el-row>
        </el-card>
      </div>
    </div>
  </div>
</template>
<script>
import tinymce from "tinymce/tinymce";
import Editor from "@tinymce/tinymce-vue";
import "tinymce/themes/silver";
import WycListBtn from "../edit/WycListBtn";
import Loading from "../../components/loading/Loading";
import { mapActions, mapState, mapMutations } from "vuex";
import config from "../../../src/assets/script/config/";
import crypto from "crypto";
import axios from "axios";
// import { saveDoc } from "../../assets/script/model";
import findWords from "../../assets/script/utils/findWords";
import Course from "@/components/share/Course";

const host = config.LongPicHost;
// 编辑器插件plugins
// 更多插件参考：https://www.tiny.cloud/docs/plugins/
// import "tinymce/plugins/image"; // 插入上传图片插件
// import "tinymce/plugins/media"; // 插入视频插件
// import "tinymce/plugins/table"; // 插入表格插件
// import "tinymce/plugins/lists"; // 列表插件
// import "tinymce/plugins/wordcount"; // 字数统计插件
// import "tinymce/plugins/imagetools"; // 图片工具
export default {
  components: {
    Editor,
    WycListBtn,
    Loading,
    Course
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    contentHeight: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      oldContent: "",
      styleItemAllColors: [
        // "rgba(19, 206, 102, 0.8)",
        // "rgba(19, 206, 102, 0.8)",
        // "rgba(19, 206, 102, 0.8)"
      ],
      w_h_rate: 100,
      angle: 0,
      alpha: 100,
      disableSelectedItemPanel: true,
      color4: "#409EFF",

      importUrl: "",
      getChangeStyleTop: 0,

      content: "",
      init: {
        // content_css: ["tinymce/neweditor.less"],
        skin_url: "/tinymce/skins/ui/oxide",
        skin: "light",
        inline: true,
        toolbar_sticky: true,
        auto_focus: true,
        language: "zh_CN",
        fixed_toolbar_container: "#mytoolbar",
        language_url: "/tinymce/langs/zh_CN.js",
        plugins: [
          // "wordcount",
          // "autosave",
          "charmap",
          "autolink",
          // "advcode", 收费
          "codesample",
          "textcolor colorpicker",
          "directionality",
          "emoticons",
          //"media mediaembed", 收费
          "fullscreen",
          "hr",
          "image",
          "imagetools",
          "insertdatetime",
          "link",
          "lists",
          "code",
          //"contextmenu",
          "preview",
          "print",
          "table",
          "searchreplace",
          "advlist",
          "lineheight",
          //"formatpainter",
          //"autoresize",
          "paste"
          //"nonbreaking"
        ],
        entity_encoding: "raw",
        menubar: "",
        //https://www.tiny.cloud/docs/advanced/editor-control-identifiers/
        // bold italic underline strikethrough blockquote alignleft aligncenter alignright lineheight outdent indent image media forecolor backcolor table hr ltr rtl
        //code link codesample numlist bullist removeformat emoticons insertdatetime formatpainter fontselect fontsizeselect formatselect   newdocument searchreplace
        toolbar: [
          "undo redo | fontselect fontsizeselect bold italic underline strikethrough forecolor backcolor | lineheight alignleft aligncenter alignright outdent indent image table | link codesample bullist numlist hr"
        ],
        imagetools_toolbar:
          "rotateleft rotateright | flipv fliph | editimage imageoptions",
        //forced_root_block: "section",
        statusbar: false,
        elementpath: false,
        visualblocks_default_state: true,

        // autosave_ask_before_unload: true,
        // autosave_interval: "3s",
        // autosave_restore_when_empty: true,
        //contextmenu_never_use_native: true,
        // autosave_retention: "1m",
        paste_filter_drop: false,
        cleanup: false,
        element_format: "html",
        schema: "html5",
        keep_styles: true,
        remove_trailing_brs: false,
        trim_span_elements: false,
        verify_html: false,
        verify_css_classes: false,
        force_p_newlines: true,
        //extended_valid_elements: "section[*],span[*]",
        valid_elements: "*[*]",
        valid_children: "+body",
        // valid_styles: {
        //   "*": "background-color"
        // },
        //tabfocus_elements: ":prev,:next",
        object_resizing: true,
        focus_alert: false,
        importcss_append: true,

        nonbreaking_force_tab: true,
        relative_urls: false,
        remove_script_host: false,
        convert_urls: false,

        paste_retain_style_properties: "all",
        paste_word_valid_elements: "*[*]", // word需要它
        paste_data_images: true, // 粘贴的同时能把内容里的图片自动上传，非常强力的功能
        paste_convert_word_fake_lists: false, // 插入word文档需要该属性
        paste_webkit_styles: false,
        paste_merge_formats: false,
        paste_auto_cleanup_on_paste: false,
        paste_enable_default_filters: false,
        paste_remove_styles_if_webkit: false,
        //去掉文本原有样式
        // paste_auto_cleanup_on_paste: true,
        // paste_enable_default_filters: true,
        // paste_remove_styles_if_webkit: false,
        // paste_strip_class_attributes: false,
        // paste_as_text: true,
        // paste_data_images: true,
        // paste_preprocess: function(plugin, args) {
        //   let content = args.content;
        //   content = content.replace(/<section[^>]*?>/gi, "<p>");
        //   content = content.replace(/<\/section>/gi, "</p>");
        //   content = content.replace(/<(?!p).*?>/gi, "");
        //   content = content.replace(/<p>(?:\s*&nbsp;\s*)*?<\/p>/gi, "");
        //   content = content.replace(/<p[^>]*?>/gi, "<p>");
        //   args.content = content;
        //   // args.content = args.content.replace(/<\/?.+?>/g, "");
        //   // args.content = args.content.replace(/ /g, "");
        // },
        height: 640,

        custom_undo_redo_levels: 100,
        images_upload_url: this.getImageHost() + "/controller.ashx",
        images_upload_base_path: config.imageShowUrl,
        images_reuse_filename: true,
        end_container_on_empty_block: true,
        imagetools_proxy: this.getImageHost() + "/image.ashx",
        automatic_uploads: true, //https://www.tiny.cloud/docs/configure/file-image-upload/#automatic_uploads
        // content_style:
        //   "._5118editor.active,.active{z-index:100;outline:1.5px dashed red!important;outline-offset:2px}::-webkit-scrollbar{width:6px;height:6px;background:#f1f1f1;}::-webkit-scrollbar-thumb{-webkit-box-shadow:inset 0 0 16px black;}::-webkit-input-placeholder{color:rgba(0,0,0,0.2);}",
        branding: false,
        imagetools_cors_hosts: ["imgcc.5ce.com", "192.168.1.101"],
        // contextmenu: "selectall copy paste inserttable",
        codesample_languages: [
          { text: "HTML/XML", value: "markup" },
          { text: "JavaScript", value: "javascript" },
          { text: "CSS", value: "css" },
          { text: "PHP", value: "php" },
          { text: "Ruby", value: "ruby" },
          { text: "Python", value: "python" },
          { text: "Java", value: "java" },
          { text: "C", value: "c" },
          { text: "C#", value: "csharp" },
          { text: "C++", value: "cpp" }
        ],
        fontsize_formats:
          "10px 11px 12px 13px 14px 15px 16px 17px 18px 19px 20px 24px 28px 32px 36px",
        font_formats:
          '微软雅黑="微软雅黑";苹方="苹方";宋体="宋体";黑体="黑体";仿宋="仿宋";楷体="楷体";隶书="隶书";幼圆="幼圆";Arial=arial,helvetica,sans-serif;Arial Black=arial black,avant garde;Book Antiqua=book antiqua,palatino;Courier New=courier new,courier;Helvetica=helvetica;Symbol=symbol;Times New Roman=times new roman,times;Verdana=verdana,geneva;',
        style_formats: [
          {
            title: "首行缩进",
            block: "section",
            styles: { "text-indent": "2em" }
          },
          {
            title: "字间距",
            items: [
              {
                title: "1",
                styles: { "letter-spacing": "1px" },
                inline: "span"
              },
              {
                title: "2",
                styles: { "letter-spacing": "2px" },
                inline: "span"
              },
              {
                title: "3",
                styles: { "letter-spacing": "3px" },
                inline: "span"
              },
              {
                title: "4",
                styles: { "letter-spacing": "4px" },
                inline: "span"
              },
              {
                title: "5",
                styles: { "letter-spacing": "5px" },
                inline: "span"
              },
              {
                title: "6",
                styles: { "letter-spacing": "6px" },
                inline: "span"
              },
              {
                title: "7",
                styles: { "letter-spacing": "7px" },
                inline: "span"
              },
              {
                title: "8",
                styles: { "letter-spacing": "8px" },
                inline: "span"
              },
              {
                title: "9",
                styles: { "letter-spacing": "9px" },
                inline: "span"
              },
              {
                title: "10",
                styles: { "letter-spacing": "10px" },
                inline: "span"
              }
            ]
          },
          {
            title: "行间距",
            items: [
              { title: "1", styles: { "line-height": "1" }, inline: "span" },
              {
                title: "1.5",
                styles: { "line-height": "1.5" },
                inline: "span"
              },
              { title: "2", styles: { "line-height": "2" }, inline: "span" },
              {
                title: "2.5",
                styles: { "line-height": "2.5" },
                inline: "span"
              },
              { title: "3", styles: { "line-height": "3" }, inline: "span" }
            ]
          },
          {
            //margin-top: 10px;
            title: "行前距",
            items: [
              {
                title: "5",
                styles: { "padding-top": "5px", display: "block" },
                inline: "span"
              },
              {
                title: "10",
                styles: { "padding-top": "10px", display: "block" },
                inline: "span"
              },
              {
                title: "15",
                styles: { "padding-top": "15px", display: "block" },
                inline: "span"
              },
              {
                title: "20",
                styles: { "padding-top": "20px", display: "block" },
                inline: "span"
              },
              {
                title: "25",
                styles: { "padding-top": "25px", display: "block" },
                inline: "span"
              }
            ]
          },
          {
            //margin-top: 10px;
            title: "行后距",
            items: [
              {
                title: "5",
                styles: { "padding-bottom": "5px", display: "block" },
                inline: "span"
              },
              {
                title: "10",
                styles: { "padding-bottom": "10px", display: "block" },
                inline: "span"
              },
              {
                title: "15",
                styles: { "padding-bottom": "15px", display: "block" },
                inline: "span"
              },
              {
                title: "20",
                styles: { "padding-bottom": "20px", display: "block" },
                inline: "span"
              },
              {
                title: "25",
                styles: { "padding-bottom": "25px", display: "block" },
                inline: "span"
              }
            ]
          }
        ],
        // https://www.tiny.cloud/docs/advanced/creating-a-sidebar/
        setup: function(editor) {
          // editor.addSidebar("mysidebar", {
          //   tooltip: "My sidebar",
          //   icon: "settings",
          //   onrender: function(api) {
          //     console.log("Render panel", api.element());
          //   },
          //   onshow: function(api) {
          //     console.log("Show panel", api.element());
          //     api.element().innerHTML = "Hello world!";
          //   },
          //   onhide: function(api) {
          //     console.log("Hide panel", api.element());
          //   }
          // }),
          editor.on("blur", function() {
            return false;
          });
          editor.on("keydown", function(event) {
            if (event.keyCode === 9) {
              editor.execCommand("mceInsertContent", false, "&emsp;&emsp;");
              event.preventDefault();
              return false;
            }
          });
        }
      },
      myValue: "",
      getid: null,
      editorWidth: 0,
      isLoadSave: false,
      dataSource: []
    };
  },
  computed: {
    ...mapState("home", ["folderId", "saveState", "saveLoading"]),
    ...mapState("wycContent", ["isShow", "openNewWycNum"]),
    ...mapState("editorControl", ["isSaveLength", "isSaveNum", "isSaveState"]),
    ...mapState("user", ["userToken"]),
    ...mapState("contents", ["wycShow"]),
    insertHtml: {
      get() {
        return this.$store.state.editorControl.insertHtml;
      },
      set(val) {
        this.$store.state.editorControl.insertHtml = val;
      }
    },
    contentWidth: {
      get() {
        return this.$store.state.contents.contentWidth;
      },
      set(val) {
        this.$store.state.contents.contentWidth = val;
      }
    },
    allContent: {
      get() {
        return this.$store.state.editorControl.allContent;
      },
      set(val) {
        this.$store.state.editorControl.allContent = val;
      }
    },
    isShowLoading: {
      get() {
        return this.$store.state.editorControl.isShowLoading;
      },
      set(val) {
        this.$store.state.editorControl.isShowLoading = val;
      }
    },
    sentence: {
      get() {
        return this.$store.state.editorControl.sentence;
      },
      set(val) {
        this.$store.state.editorControl.sentence = val;
      }
    },
    getTitle: {
      get() {
        return this.$store.state.wycContent.getTitle;
      },
      set(val) {
        this.$store.state.wycContent.getTitle = val;
      }
    },
    contentCount: {
      get() {
        return this.$store.state.editorControl.contentCount;
      },
      set(val) {
        this.$store.state.editorControl.contentCount = val;
      }
    },
    contentPic: {
      get() {
        return this.$store.state.editorControl.contentPic;
      },
      set(val) {
        this.$store.state.editorControl.contentPic = val;
      }
    },
    insertDoc: {
      get() {
        return this.$store.state.editorControl.insertDoc;
      },
      set(val) {
        this.$store.state.editorControl.insertDoc = val;
      }
    },
    rightShow: {
      get() {
        return this.$store.state.contents.rightShow;
      },
      set(val) {
        this.$store.state.contents.rightShow = val;
      }
    },
    leftShow: {
      get() {
        return this.$store.state.contents.leftShow;
      },
      set(val) {
        this.$store.state.contents.leftShow = val;
      }
    },
    rightTitle: {
      get() {
        return this.$store.state.contents.rightTitle;
      },
      set(val) {
        this.$store.state.contents.rightTitle = val;
      }
    },
    isOriginal: {
      get() {
        return this.$store.state.editorControl.isOriginal;
      },
      set(val) {
        return (this.$store.state.editorControl.isOriginal = val);
      }
    },
    docUpdate: {
      get() {
        return this.$store.state.material.docUpdate;
      },
      set(val) {
        this.$store.state.material.docUpdate = val;
      }
    }
  },
  // updated() {
  //   let getTinymceBox = document.getElementsByClassName("tox-tinymce")[0];
  //   if (getTinymceBox) this.fixEditorHeight(this.contentHeight);
  // },
 async mounted() {
    this.getid = setInterval(() => {
      let getTinymceBox = document.getElementsByClassName("tox-tinymce")[0];
      if (getTinymceBox) {
        clearInterval(this.getid);
        tinymce.init({});

        let getContent = tinymce.util.LocalStorage.getItem("lastEditorContent");
        if (getContent) {
          if (getContent.indexOf('"title":') === -1) {
            tinymce.util.LocalStorage.setItem(
              "lastEditorContent",
              JSON.stringify(this.insertDoc)
            );
          }
        }
        // this.fixEditorHeight(this.contentHeight);
        this.editorWidth = document.getElementsByClassName(
          "tinymce-editor"
        )[0].offsetWidth;
        let changeStyleMain = document.getElementsByClassName(
          "changeStyleMain"
        )[0];
        changeStyleMain.style.marginLeft = this.editorWidth - 400 - 50 + "px";

        let mbtn = document.getElementById("menuBtn");
        if (this.contentWidth < 1435)
          mbtn.style.marginLeft = this.editorWidth - 30 + "px";
        else mbtn.style.marginLeft = this.editorWidth - 10 + "px";
        let that = this;
        window.onresize = function temp() {
          that.contentWidth = document.documentElement.clientWidth;
          changeStyleMain.style.marginLeft = that.editorWidth - 400 - 50 + "px";
          that.editorWidth = document.getElementsByClassName(
            "tinymce-editor"
          )[0].offsetWidth;
          if (document.documentElement.clientWidth < 1435)
            mbtn.style.marginLeft = that.editorWidth - 30 + "px";
          else mbtn.style.marginLeft = that.editorWidth - 10 + "px";
        };
        //鼠标划词事件
        this.addEvent();
        //设置顶部菜单滚动阴影
        this.setBoxShadow();
        //关闭编辑器提示
        this.closeWindow();
        //监听Crtl+S保存按键
        this.ListenerKeyDown();
        //弹出离开提示框
        this.isSetSaveState(true);
        // let getnew = document.getElementsByClassName("tox-tbtn")[2];
        // getnew.title = "清空内容";

        setInterval(async () => {
          if (this.oldContent !== tinymce.activeEditor.getBody().innerHTML) {
            if (
              tinymce.activeEditor.getBody().innerHTML !== "" &&
              tinymce.activeEditor.getBody().innerHTML !==
                `<p><br data-mce-bogus="1"></p>`
            ) {
              await this.saveArticels(2);
              this.oldContent = tinymce.activeEditor.getBody().innerHTML;
            }
          }
        }, 10000);
      }
    }, 300);
  //  var result=await this.AGetFriendship();
  //          if(result.errorCode==0 && result.data.rowCount>0){

  //           this.dataSource=result.data.dataSource;
  //          }
  },
  methods: {
    ...mapActions("api", ["AFavoriteParagraph", "APermission", "ADocDetail",'AGetFriendship']),
    ...mapActions("editorControl", ["ADocInsert"]),
    ...mapMutations("home", ["setSaveState", "setSaveLoading"]),
    ...mapMutations("editorControl", ["setisSaveState"]),
    isSetSaveState(type) {
      this.setisSaveState(type);
    },
    selection(root) {
      try {
        return root
          .getSelection()
          .getRangeAt(0)
          .cloneContents().textContent;
      } catch (e) {
        console.log(e);
        return "";
      }
    },
    setTimeoutAsync(time) {
      return new Promise(resolve => {
        setTimeout(() => {
          resolve();
        }, time);
      });
    },
    //清除空白字符
    Trim(str) {
      return str.replace(/(^\\s*)|(\\s*$)/gi, "");
    },
    //设置工具栏滚动阴影
    setBoxShadow() {
      window.onscroll = () => {
        //变量t是滚动条滚动时，距离顶部的距离
        var t = document.documentElement.scrollTop || document.body.scrollTop;
        var scrollup = document.getElementById("mytoolbar");
        //当滚动到距离顶部200px时，返回顶部的锚点显示
        if (t >= 200) {
          scrollup.style.boxShadow = "0px 7px 7px -7px #666";
        } else {
          //恢复正常
          scrollup.style.boxShadow = "";
        }
      };
    },
    async mouseEvent() {
      document.querySelectorAll("._5118-intro-btn[data-tool]").forEach(item => {
        item.parentNode.removeChild(item);
      });
      await this.setTimeoutAsync(10);
      let text = "";

      text = this.selection(window);
      window._getSelectText = text;

      let select = this.getSelection(window);
      if (text) {
        let rect = this.getSelectionRect(select);
        let btn = document.createElement("div");
        btn.classList.add("_5118-intro-btn");
        btn.style.position = "fixed";
        btn.style.left = rect.left + (rect.width - 240) / 2 + "px";
        btn.style.zIndex = "2147483646";
        btn.style.top = rect.top - 50 + "px";
        btn.style.display = "inline-block";
        btn.style.whiteSpace = "nowrap";
        btn.style.cursor = "pointer";
        btn.style.textAlign = "center";
        btn.style.outline = "none";
        btn.style.margin = "0";
        btn.style.transition = ".1s";
        btn.style.fontWeight = "500";
        btn.style.fontSize = "14px";
        // btn.style.backgroundColor = "#5388f8";
        // btn.style.border = "1px solid #5388f8";
        btn.style.color = "white";
        btn.style.borderRadius = "2px";
        btn.style.display = "flex";
        // btn.style.borderRadius = "20px";

        let btn1 = document.createElement("div");
        btn1.textContent = "整句原创";
        btn1.style.width = "80px";
        btn1.style.padding = "7px 10px";
        btn1.style.backgroundColor = "#167df3";
        btn1.style.borderRadius = "0 25px 25px 0";
        btn1.onmouseenter = function() {
          btn1.style.backgroundColor = "#156ed1";
        };
        btn1.onmouseleave = function() {
          btn1.style.backgroundColor = "#167df3";
        };
        let btn2 = document.createElement("div");
        btn2.textContent = "原创检测";
        btn2.style.width = "80px";
        btn2.style.padding = "7px 10px";
        btn2.style.backgroundColor = "#167df3";
        btn2.style.borderRight = "1px solid #626d84";
        btn2.onmouseenter = function() {
          btn2.style.backgroundColor = "#156ed1";
          out.style.borderTop = "10px solid #156ed1";
          out.style.borderLeft = "7px solid transparent";
          out.style.borderRight = "7px solid transparent";
        };
        btn2.onmouseleave = function() {
          btn2.style.backgroundColor = "#167df3";
          out.style.borderTop = "10px solid #167df3";
          out.style.borderLeft = "7px solid transparent";
          out.style.borderRight = "7px solid transparent";
        };

        let btn3 = document.createElement("div");
        btn3.textContent = "收藏";
        btn3.style.width = "80px";
        btn3.style.padding = "7px 10px";
        btn3.style.backgroundColor = "#167df3";
        btn3.style.borderRadius = "25px 0 0 25px";
        btn3.style.borderRight = "1px solid #626d84";
        btn3.onmouseenter = function() {
          btn3.style.backgroundColor = "#156ed1";
        };
        btn3.onmouseleave = function() {
          btn3.style.backgroundColor = "#167df3";
        };

        let out = document.createElement("div");
        out.style.position = "absolute";
        out.style.top = "30px";
        out.style.left = "120px";
        out.style.borderTop = "10px solid #167df3";
        out.style.borderLeft = "7px solid transparent";
        out.style.borderRight = "7px solid transparent";

        btn.appendChild(btn3);
        btn.appendChild(btn2);
        btn.appendChild(btn1);
        btn.appendChild(out);

        btn.addEventListener("mouseup", e => {
          e.stopPropagation();
        });
        document.addEventListener("mouseup", e => {
          e.stopPropagation();
          btn.style.display = "none";
        });
        btn1.addEventListener("click", async e => {
          e.stopPropagation();
          let result = await this.APermission({ SysName: "wyctranslate" });
          if (result.errorCode > 0) {
            this.isUse = true;
            if (result.errorCode === 300000) {
              btn.style.display = "none";
              this.insertConfig.showLoginMessage(
                true,
                "您当前账号暂未登录，请登录账号享更多权限",
                ""
              );
            } else {
              this.$message({
                showClose: true,
                message: result.errorMess,
                type: "error"
              });
            }
            return;
          }
          if (result.data > 0 || result.data === -1) {
            if (this.Trim(text).length <= 300) {
              btn.style.display = "none";
              this.rightTitle = "整句原创";
              this.rightShow = true;
              this.sentence = this.Trim(text);
            } else {
              btn.style.display = "none";
              this.$message({
                showClose: true,
                message: "整句智能原创不能超过300字符",
                type: "warning "
              });
            }
          } else {
            btn.style.display = "none";
            this.insertConfig.showUpgrade(true, "获取更多使用次数");
          }
        });
        btn2.addEventListener("click", async e => {
          e.stopPropagation();
          let result = await this.APermission({ SysName: "wycoriginalfull" });
          if (result.errorCode > 0) {
            this.isUse = true;
            if (result.errorCode === 300000) {
              btn.style.display = "none";
              this.insertConfig.showLoginMessage(
                true,
                "您当前账号暂未登录，请登录账号享更多权限",
                ""
              );
            } else {
              this.$message({
                showClose: true,
                message: result.errorMess,
                type: "error"
              });
            }
            return;
          }
          if (result.data > 0 || result.data === -1) {
            btn.style.display = "none";
            this.rightTitle = "原创检测";
            this.sentence = this.Trim(text);
            this.rightShow = true;
            this.isOriginal = true;
          } else {
            btn.style.display = "none";
            this.insertConfig.showUpgrade(true, "获取更多使用次数");
          }
        });
        btn3.addEventListener("click", async e => {
          e.stopPropagation();
          btn.style.display = "none";
          let result = await this.AFavoriteParagraph({
            title: this.Trim(text),
            content: this.Trim(text)
          });
          if (result.errorCode === 0) {
            this.$message({
              showClose: true,
              message: "收藏段落成功",
              type: "success"
            });
          } else {
            if (result.errorCode === 300000) {
              this.insertConfig.showLoginMessage(
                true,
                "您当前账号暂未登录，请登录账号享更多权限",
                ""
              );
            } else {
              this.$message({
                showClose: true,
                message: result.errorMess,
                type: "error"
              });
            }
          }
        });
        btn.dataset["tool"] = Date.now().toString();
        document.body.appendChild(btn);
      }
    },
    addEvent() {
      let contentDom = document.getElementsByClassName("mce-content-body")[0];
      contentDom.addEventListener("mouseup", this.mouseEvent, false);
    },
    getSelection(root) {
      let t = null;
      if (root.getSelection) {
        t = root.getSelection();
      } else if (root.document.getSelection) {
        t = root.document.getSelection();
      } else if (root.document.selection) {
        t = root.document.selection.createRange().text;
      }
      return t;
    },
    getSelectionRect(selection) {
      if (selection.rangeCount <= 0) {
        return null;
      }
      const _rect = selection.getRangeAt(0).getBoundingClientRect();
      let rect =
        _rect && _rect.top
          ? _rect
          : selection.getRangeAt(0).getClientRects()[0];
      if (!rect) {
        if (
          selection.anchorNode &&
          selection.anchorNode.getBoundingClientRect
        ) {
          rect = selection.anchorNode.getBoundingClientRect();
        } else {
          return null;
        }
      }
      return rect;
    },

    // 添加相关的事件，可用的事件参照文档=> https://github.com/tinymce/tinymce-vue => All available events
    // 需要什么事件可以自己增加
    // onClick(e) {
    //   this.$emit("onClick", e, tinymce);
    // },
    // 可以添加一些自己的自定义事件，如清空内容
    clear() {
      this.myValue = "";
    },
    getImageHost() {
      return config.imageUploadUrl;
    },
    // fixEditorHeight(newContentHeight) {
    //   //console.log(newContentHeight);
    //   let toolbar = document.querySelector(".el-header");
    //
    //   let editorToolbarHeight = 0;
    //   if (toolbar !== null && toolbar !== undefined) {
    //     editorToolbarHeight = toolbar.offsetHeight;
    //   }
    //   let editorStatusBarHeight = 75;
    //   // let editorStatusBarHeight =
    //   //   document.querySelector(".mce-statusbar").offsetHeight + 2;
    //
    //   let realHeight =
    //     newContentHeight - editorToolbarHeight - editorStatusBarHeight;
    //
    //   if (typeof tinymce !== "undefined" && tinymce.activeEditor != null) {
    //     let getTinymceBox = document.getElementsByClassName(
    //       "mce-content-body111"
    //     )[0];
    //     getTinymceBox.style.height = realHeight + "px";
    //   }
    // },

    saveLoaclContent() {
      // console.log(this.isLoadSave);
      if (tinymce.activeEditor != null && this.isLoadSave) {
        let getContent = tinymce.util.LocalStorage.getItem("lastEditorContent");
        if (getContent) {
          this.insertDoc = JSON.parse(getContent);
        }
        let getText = tinymce.activeEditor
          .getBody()
          .innerText.replace("\r", "")
          .replace("\n", "");
        this.contentCount = getText.length;
        const dom = tinymce.activeEditor.getBody();
        const imgList = dom.getElementsByTagName("img");
        this.contentPic = imgList.length;
        this.insertDoc.title = this.getTitle;
        if (this.getSessionDocId()) {
          this.insertDoc.docId = this.getSessionDocId();
        } else {
          this.insertDoc.docId = "";
        }

        this.insertDoc.content = tinymce.activeEditor.getBody().innerHTML;
        tinymce.util.LocalStorage.setItem(
          "lastEditorContent",
          JSON.stringify(this.insertDoc)
        );
      }
    },
    editorChanged() {
      this.saveLoaclContent();
      setTimeout(() => {
        if (document.getElementsByClassName("flicker")[0]) {
          let flicker = document.querySelector(".flicker");
          flicker.classList.remove("flicker");
        }
      }, 1000);
    },
    titleChanged() {
      // console.log(this.isLoadSave);
      if (this.getTitle != null && this.isLoadSave) {
        this.$nextTick(() => {
          let getContent = tinymce.util.LocalStorage.getItem(
            "lastEditorContent"
          );
          if (getContent) {
            this.insertDoc = JSON.parse(getContent);
          }
          this.insertDoc.title = this.getTitle;
          this.insertDoc.content = tinymce.activeEditor.getBody().innerHTML;
          if (this.getSessionDocId()) {
            this.insertDoc.docId = this.getSessionDocId();
          } else {
            this.insertDoc.docId = "";
          }
          tinymce.util.LocalStorage.setItem(
            "lastEditorContent",
            JSON.stringify(this.insertDoc)
          );
        });
      }
    },
    getPicCount(text) {
      console.log(text);
    },
    async editorInited() {
      if (this.$route.name === "materialNew") {
        this.isLoadSave = true;
        return;
      }
      let lastEditorContent = tinymce.util.LocalStorage.getItem(
        "lastEditorContent"
      );
      if (lastEditorContent) {
        // this.insertDoc = new saveDoc();
        // let newDoc = Object.assign(
        //   this.insertDoc,
        //   JSON.parse(lastEditorContent)
        // );
        // this.insertDoc = newDoc;
        // if (this.insertDoc.userToken !== this.userToken) {
        //   this.insertDoc.userToken = this.userToken;
        // } else {
        //   tinymce.activeEditor.getBody().innerHTML = this.insertDoc.content;
        // }
        this.insertDoc = JSON.parse(lastEditorContent);
        if (this.getSessionDocId()) {
          let result = await this.ADocDetail({ docId: this.getSessionDocId() });
          if (result.errorCode === 0) {
            let detailList = result.data;
            if (
              this.insertDoc.docId.toString() === detailList.docId.toString()
            ) {
              tinymce.activeEditor.getBody().innerHTML = this.insertDoc.content;
              this.insertDoc.title !== ""
                ? (this.getTitle = this.insertDoc.title)
                : (this.getTitle = detailList.title);
              this.setSessionDocId(this.insertDoc.docId);
              this.isLoadSave = true;
            } else {
              tinymce.activeEditor.getBody().innerHTML = detailList.content;
              this.getTitle = detailList.title;
              this.insertDoc.docId = detailList.docId;
              this.isLoadSave = true;
            }
          } else {
            this.getTitle = this.insertDoc.title;
            tinymce.activeEditor.getBody().innerHTML = this.insertDoc.content;
            this.setSessionDocId(this.insertDoc.docId);
            this.isLoadSave = true;
          }
        } else {
          this.getTitle = this.insertDoc.title;
          tinymce.activeEditor.getBody().innerHTML = this.insertDoc.content;
          this.setSessionDocId(this.insertDoc.docId);
          this.isLoadSave = true;
        }

        let getText = tinymce.activeEditor
          .getBody()
          .innerText.replace("\r", "")
          .replace("\n", "");
        this.contentCount = getText.length;
        const dom = tinymce.activeEditor.getBody();
        const imgList = dom.getElementsByTagName("img");
        this.contentPic = imgList.length;
        tinymce.activeEditor.dom.removeClass(
          tinymce.activeEditor.dom.select(".n_active"),
          "n_active"
        );
        tinymce.util.LocalStorage.setItem(
          "lastEditorContent",
          JSON.stringify(this.insertDoc)
        );
      } else {
        let newHtml = "<br/>";
        this.isLoadSave = true;
        tinymce.activeEditor.setContent(newHtml);
        tinymce.activeEditor.execCommand("fontName", false, "微软雅黑");
        tinymce.activeEditor.execCommand("fontSize", false, "14px");
      }
    },
    onClickItem() {
      this.saveLoaclContent();
      if (
        tinymce.activeEditor != null &&
        tinymce.activeEditor.selection != null
      ) {
        let selectedNode = tinymce.activeEditor.selection.getNode();

        let styleItemParent = this.activeItem(
          selectedNode,
          this.getEditorDoc()
        );

        this.selectedStyleItemParent = styleItemParent;

        //控制是否禁止扩展操作控件
        this.disableSelectedItemPanel = true;
        if (styleItemParent != null && styleItemParent.tagName === "SECTION") {
          //初始化宽度
          let widthValue = styleItemParent.offsetWidth;
          let dom = document.getElementsByClassName("mce-content-body")[0];
          let editWidth = dom.offsetWidth - 100;
          // ToDo404需要根据实际宽度调整
          // if (this.w_h_rate === 100) {
          this.w_h_rate = parseInt((widthValue / editWidth) * 100);
          // }

          //console.log(this.w_h_rate);

          //初始化透明度

          let alphaValue = 100;
          if (styleItemParent.style.opacity !== "") {
            alphaValue = parseFloat(styleItemParent.style.opacity) * 100;
          }

          this.alpha = alphaValue;
          //console.log("alpha:" + this.alpha);

          //初始化角度
          let angleValue = styleItemParent.style.getPropertyValue("transform");
          let angleValueInt = 0;
          if (angleValue) {
            //rotatez(-152deg)

            angleValueInt = parseInt(
              angleValue
                .toString()
                .toLowerCase()
                .replace("rotatez(", "")
                .replace("deg)", "")
            );
          }

          this.angle = angleValueInt;

          this.InitColorPick(styleItemParent);

          this.disableSelectedItemPanel = false;
          this.$nextTick(() => {
            this.editorWidth = document.getElementsByClassName(
              "tinymce-editor"
            )[0].offsetWidth;
            let changeStyleMain = document.getElementsByClassName(
              "changeStyleMain"
            )[0];
            changeStyleMain.style.marginLeft =
              this.editorWidth - 400 - 50 + "px";
          });

          let getSelectStyle = document.getElementsByClassName("n_active")[0];
          if (getSelectStyle) {
            this.getChangeStyleTop = getSelectStyle.offsetTop;
            let getStyleHeight = getSelectStyle.offsetHeight;
            this.getChangeStyleTop =
              this.getChangeStyleTop + getStyleHeight + 295;
          }
        } else {
          // if (tinymce.activeEditor.selection.getNode().innerText.length > 5) {
          //   tinymce.activeEditor.selection.select(
          //     tinymce.activeEditor.selection.getNode()
          //   );
          // }
        }
      }
    },
    InitColorPick(styleItemParent) {
      if (styleItemParent != null && styleItemParent.querySelectorAll != null) {
        //初始化颜色
        this.styleItemAllColors = [];
        let styleItemAllColorsLocal = this.styleItemAllColors;

        //遍历所有section寻找所有颜色
        [].forEach.call(styleItemParent.querySelectorAll("section"), function(
          foundSection
        ) {
          //console.log(foundSection);
          //console.log(foundSection.style);
          if (styleItemParent !== foundSection) {
            for (let i = 0, len = foundSection.style.length; i < len; i++) {
              let prop = foundSection.style[i];

              //console.log(prop);

              let propValue = foundSection.style.getPropertyValue(prop);
              if (propValue.indexOf("rgb") !== -1) {
                //rgb(156, 80, 60)

                //console.log(propValue);

                let rgbRe = /rgb\(\s*[\d\\.]+\s*,\s*[\d\\.]+\s*,\s*[\d\\.]+\s*\)/g;
                let rgbArr = propValue.match(rgbRe);

                if (rgbArr === null) {
                  rgbRe = /rgba\(\s*[\d\\.]+\s*,\s*[\d\\.]+\s*,\s*[\d\\.]+\s*,\s*[\d\\.]+\s*\)/g;
                  rgbArr = propValue.match(rgbRe);

                  //console.log(rgbArr);
                }

                rgbArr.forEach(rgb => {
                  //console.log(rgb);
                  if (styleItemAllColorsLocal.indexOf(rgb) === -1) {
                    styleItemAllColorsLocal.push(rgb);
                  }
                });
              }
            }
          }
        });
      }
    },
    styleItemPickColorChange(currentColor) {
      let styleItemParent = this.selectedStyleItemParent;
      if (styleItemParent != null && styleItemParent.querySelectorAll != null) {
        let lastClickPickColor = this.lastClickPickColor;

        [].forEach.call(styleItemParent.querySelectorAll("section"), function(
          foundSection
        ) {
          //console.log(foundSection);
          //console.log(foundSection.style);
          if (styleItemParent !== foundSection) {
            for (let i = 0, len = foundSection.style.length; i < len; i++) {
              let prop = foundSection.style[i];

              let propValue = foundSection.style.getPropertyValue(prop);
              // console.log("当前属性：" + prop);
              // console.log("当前属性值" + propValue);
              // console.log("原始值：" + lastClickPickColor);

              if (propValue.indexOf(lastClickPickColor) !== -1) {
                //console.log("新值：" + currentColor);
                //console.log("原始值：" + lastClickPickColor);

                tinymce.activeEditor.dom.setStyle(
                  foundSection,
                  prop,
                  propValue.replace(lastClickPickColor, currentColor)
                );

                // //如果找到了原始值，那么就开始替换
                // foundSection.style.setProperty(
                //   prop,
                //   propValue.replace(lastClickPickColor, currentColor)
                // );
              }
            }
          }
        });

        //保存替换后的颜色
        this.lastClickPickColor = currentColor;

        this.InitColorPick(styleItemParent);

        this.setDirty();
      }
    },
    setDirty() {
      //tinymce.activeEditor.setDirty(true);
      tinymce.activeEditor.fire("Change");
      //tinymce.activeEditor.execCommand("mceInsertContent", false, "");
    },
    styleItemParentOuter() {
      return this.selectedStyleItemParent.parentNode;
    },
    contentChange() {
      //this.deactiveItem(this.getEditorDoc());
    },
    pickerClick(index) {
      this.lastClickPickColor = this.styleItemAllColors[index];
      //console.log(this.lastClickPickColor);
    },
    restoreAngle() {
      this.angle = 0;
      this.angleChanged(0);
    },
    angleChanged(newAngle) {
      let styleItemParent = this.selectedStyleItemParent;

      //transform: rotatez(-21deg);
      //-webkit-transform: rotatez(-21deg);
      //-moz-transform: rotatez(-21deg);
      //.-o-transform: rotatez(-21deg);
      let newAngleStr = "rotatez(" + newAngle + "deg)";
      //console.log(newAngleStr);
      // styleItemParent.style.setProperty("transform", newAngleStr);
      // styleItemParent.style.setProperty("-webkit-transform", newAngleStr);
      // styleItemParent.style.setProperty("-moz-transform", newAngleStr);
      // styleItemParent.style.setProperty(".-o-transform", newAngleStr);
      this.setVendor(styleItemParent, "transform", newAngleStr);

      //margin: 0px auto;
      styleItemParent.style.setProperty("margin", "0px auto");

      this.setDirty();
    },
    restoreW_h_rate() {
      this.w_h_rate = 100;
      this.widthChanged(this.w_h_rate);
    },
    inputAlphaChanged() {
      this.$nextTick(() => {
        this.alphaChanged(this.$refs.inputAlpha.value);
        this.alpha = parseFloat(this.$refs.inputAlpha.value);
      });
    },
    inputWidthChanged() {
      this.$nextTick(() => {
        this.widthChanged(this.$refs.inputw_h_rate.value);
        this.w_h_rate = parseInt(this.$refs.inputw_h_rate.value);
      });
    },
    widthChanged(newWidth) {
      let styleItemParent = this.selectedStyleItemParent;
      styleItemParent.style.width = newWidth + "%";

      //margin: 0px auto;
      styleItemParent.style.setProperty("margin", "0px auto");

      this.setDirty();
    },
    restoreAlpha() {
      this.alpha = 100;
      this.alphaChanged(100);
    },
    alphaChanged(newAlpha) {
      //opacity: 0.66;
      let styleItemParent = this.selectedStyleItemParent;
      styleItemParent.style.opacity = newAlpha / 100;

      //margin: 0px auto;
      styleItemParent.style.setProperty("margin", "0px auto");

      this.setDirty();
    },
    insertLineAfter() {
      // let styleItemParent = this.selectedStyleItemParent;
      let newNodeBr = document.createElement("p");
      newNodeBr.innerHTML = "&nbsp";
      this.insertAfter(newNodeBr, this.styleItemParentOuter());

      this.setDirty();

      this.focusCursor(newNodeBr);
    },
    insertLineBefore() {
      // let styleItemParent = this.selectedStyleItemParent;
      let newNodeBr = document.createElement("p");
      newNodeBr.innerHTML = "&nbsp";
      this.insertBefore(newNodeBr, this.styleItemParentOuter());

      this.setDirty();

      this.focusCursor(newNodeBr);
    },
    moveOutSiblingsNodes(styleItemParent) {
      //把所有兄弟全部移动出去
      let allSiblingsNodes = this.getAllSiblingsNodesAfter(styleItemParent);
      for (let i = 0; i < allSiblingsNodes.length; i++) {
        let allSiblingsNode = allSiblingsNodes[i];
        if (
          allSiblingsNode.tagName === "SECTION" &&
          styleItemParent.parentNode.tagName != "BODY"
        ) {
          this.insertAfter(allSiblingsNode, styleItemParent.parentNode);
        }
      }
    },
    moveElement(styleItemParent, direction) {
      //把所选样式的外框移动到同级外框前面
      console.log(styleItemParent);
      let allSiblingsNodes;
      if (direction === "before") {
        allSiblingsNodes = this.getAllSiblingsNodesBefore(
          styleItemParent.parentNode
        );
      } else {
        allSiblingsNodes = this.getAllSiblingsNodesAfter(
          styleItemParent.parentNode
        );
      }

      //console.log(allSiblingsNodes);
      let hasMoved = false;

      if (direction === "before") {
        allSiblingsNodes = this.reverseArray(allSiblingsNodes);
      }

      for (let i = 0; i < allSiblingsNodes.length; i++) {
        let allSiblingsNode = allSiblingsNodes[i];
        //if (allSiblingsNode.tagName === "SECTION") {
        if (direction === "before") {
          this.insertBefore(styleItemParent.parentNode, allSiblingsNode);
        } else {
          this.insertAfter(styleItemParent.parentNode, allSiblingsNode);
        }

        tinymce.activeEditor.selection.select(styleItemParent);
        tinymce.activeEditor.selection.collapse(false);
        tinymce.activeEditor.execCommand("mceInsertContent", false, "");

        this.flashBackground(styleItemParent);

        hasMoved = true;
        break;
      }
      //}

      tinymce.activeEditor.focus();
      return hasMoved;
    },
    moveUp() {
      let styleItemParent = this.selectedStyleItemParent;

      //把所有兄弟移出去
      this.moveOutSiblingsNodes(styleItemParent.parentNode);

      //往上面移动
      let hasMoved = this.moveElement(styleItemParent, "before");

      //如果移动不了，就移动上层的
      if (hasMoved === false) {
        let foundRootItemStyle = this.findStyleItemRootWithStyle(
          styleItemParent
        );
        if (foundRootItemStyle != null) {
          hasMoved = this.moveElement(foundRootItemStyle, "before");
        }
      }

      if (hasMoved === false) {
        // this.$notify.info({
        //   title: "提示",
        //   message: "已经在同级元素中处于最顶部"
        // });
        this.$message({
          message: "已经在同级元素中处于最顶部",
          showClose: true,
          type: "success"
        });
      } else {
        this.setDirty();
      }
    },
    moveDown() {
      let styleItemParent = this.selectedStyleItemParent;

      this.moveOutSiblingsNodes(styleItemParent.parentNode);

      let hasMoved = this.moveElement(styleItemParent, "after");

      if (hasMoved === false) {
        let foundRootItemStyle = this.findStyleItemRootWithStyle(
          styleItemParent
        );
        if (foundRootItemStyle != null) {
          hasMoved = this.moveElement(foundRootItemStyle, "after");
        }
      }

      if (hasMoved === false) {
        // this.$notify.info({
        //   title: "提示",
        //   message: "已经在同级元素中处于最底部"
        // });
        this.$message({
          message: "已经在同级元素中处于最底部",
          showClose: true,
          type: "success"
        });
      } else {
        this.setDirty();
      }
    },
    focusCursor(element) {
      tinymce.activeEditor.selection.setCursorLocation(element);

      this.flashBackground(element);

      tinymce.execCommand("mceFocus", false, "intymceEditor");
    },
    selectStyle() {
      this.selectStyleFun(this.styleItemParentOuter());
    },
    selectStyleFun(styleItemParent) {
      //console.log(styleItemParent);

      tinymce.activeEditor.selection.select(styleItemParent, true);

      this.deactiveItem(this.getEditorDoc());

      tinymce.execCommand("mceFocus", false, "intymceEditor");
    },
    copyStyle() {
      this.selectStyleFun(this.styleItemParentOuter());

      tinymce.activeEditor.execCommand("copy", false);
      //tinymce.activeEditor.getDoc().execCommand("copy");
    },
    cutStyle() {
      let styleItemParent = this.styleItemParentOuter();

      this.selectStyleFun(styleItemParent);

      tinymce.activeEditor.execCommand("copy", false);
      //tinymce.activeEditor.getDoc().execCommand("copy");

      styleItemParent.parentNode.removeChild(styleItemParent);

      this.setDirty();
    },
    deleteStyle() {
      let styleItemParent = this.styleItemParentOuter();

      this.disableSelectedItemPanel = true;

      styleItemParent.parentNode.removeChild(styleItemParent);

      this.setDirty();
    },
    clearItemStyle() {
      let styleItemParent = this.selectedStyleItemParent;

      let allChildNodes = [];
      this.getAllChildNode(allChildNodes, styleItemParent);

      for (let j = 0; j < allChildNodes.length; j++) {
        allChildNodes[j].setAttribute("style", "");
      }
      this.$message({
        message: "样式清除成功",
        showClose: true,
        type: "success"
      });

      this.setDirty();
    },
    serachByID() {
      let styleItemParent = this.selectedStyleItemParent;
      let styleID = styleItemParent.getAttribute("styleid");
      if (styleID === null) {
        styleID = styleItemParent.getAttribute("data-id");

        if (styleID === null) {
          styleID = styleItemParent.getAttribute("id");
        }
      }
      this.$store.commit("SetSearchStyleID", styleID);
      //console.log(styleID);
    },
    passItemStyle() {
      let styleItemParent = this.selectedStyleItemParent;
      let selectedStyleDataId = tinymce.activeEditor.dom.getAttrib(
        styleItemParent,
        "styleid"
      );

      let allChildNodes = [this.selectedStyleItemParent];
      this.getAllChildNode(allChildNodes, styleItemParent);

      let items = tinymce.activeEditor.dom.select("._5118editor");

      let successTimes = 0;
      let failedTimes = 0;
      for (let i = 0; i < items.length; i++) {
        let sameItem = items[i];
        let sameItemStyleDataId = tinymce.activeEditor.dom.getAttrib(
          sameItem,
          "styleid"
        );

        if (
          sameItem !== styleItemParent &&
          sameItemStyleDataId === selectedStyleDataId
        ) {
          // console.log(sameItemStyleDataId);
          // console.log(sameItem);

          // console.log(selectedStyleDataId);
          // console.log(styleItemParent);

          let sameItemAllChildNodes = [sameItem];
          this.getAllChildNode(sameItemAllChildNodes, sameItem);
          //console.log(allChildNodes);

          if (allChildNodes.length === sameItemAllChildNodes.length) {
            successTimes++;
            for (let j = 0; j < allChildNodes.length; j++) {
              sameItemAllChildNodes[j].setAttribute(
                "style",
                allChildNodes[j].getAttribute("style")
              );
            }
          } else {
            failedTimes++;
          }

          var messageStr = "成功为你复制风格到" + successTimes + "个同类样式";
          if (failedTimes > 0) {
            messageStr += "，" + failedTimes + "个因为样式结构已被修改而放弃";
          }
        }
      }

      // this.$notify({
      //   title: "成功",
      //   message: messageStr,
      //   type: "success"
      // });
      this.$message({
        message: messageStr,
        showClose: true,
        type: "success"
      });

      this.setDirty();
    },
    importContentFromWeixin() {
      console.log(this.importUrl);

      this.loadingService = this.$loading({
        lock: true,
        text: "文章导入中",
        spinner: "el-icon-loading",
        // background: "rgba(0, 0, 0, 0.7)",
        target: document.querySelector("#editorAndAdvPanel")
      });

      // this.axios
      //   .get(this.getImportAPI(this.importUrl))
      //   .then(response => {
      //     //console.log(response.data);
      //     //tinymce.activeEditor.setContent(response.data);
      //
      //     tinymce.activeEditor.dom.setHTML(
      //       tinymce.activeEditor.getBody(),
      //       response.data
      //     );
      //
      //     this.setDirty();
      //
      //     this.loadingService.close();
      //   })
      //   .catch(error => {
      //     console.log(error);
      //     this.$message.error("导入微信公众号文章时发生错误: " + error);
      //   });
    },
    getImportAPI(url) {
      if (process.env.NODE_ENV === "development") {
        return "https://192.168.1.202:5010/api/Html?url=" + escape(url);
      } else {
        return "https://ai.5118.com:5010/api/Html?url=" + escape(url);
      }
    },
    getGenImageAPI() {
      return config.imageSaveUrl;
    },
    genLongImage(imageWidth) {
      this.deactiveItem(this.getEditorDoc());

      this.loadingService = this.$loading({
        lock: true,
        text: "正在生成长图，请耐心等待",
        spinner: "el-icon-loading",
        customClass: "cut_longimg_loading",
        // background: "rgba(0, 0, 0, 0.7)",
        target: document.querySelector("#editorAndAdvPanel")
      });
      let bodyHtml =
        '<!DOCTYPE html><html><head><title>test</title><meta http-equiv="X-UA-Compatible" content="IE=edge,chrome=1"><meta http-equiv="content-type" content="text/html;charset=utf-8"><link rel="stylesheet" type="text/css" href="' +
        host +
        '/tinymce/editor.css"></head><body>' +
        tinymce.activeEditor.getContent({ format: "raw" }) +
        "</body></html>";
      let md5 = crypto.createHash("md5");
      md5.update(bodyHtml);
      let bodyHtmlHash = md5.digest("hex");
      let imageHost = host;

      let headers = {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
        }
      };

      // let params = new URLSearchParams();
      // params.append("html", escape(bodyHtml));
      // params.append("hash", escape(bodyHtmlHash));
      let params = JSON.stringify({
        html: escape(bodyHtml),
        hash: escape(bodyHtmlHash),
        imageHost: escape(imageHost),
        imageWidth: escape(imageWidth)
      });
      axios
        //.get(this.getGenImageAPI(this.importUrl))
        .post(this.getGenImageAPI(), params, headers)
        .then(response => {
          // console.log(response.data);
          //tinymce.activeEditor.setContent(response.data);

          this.loadingService.close();
          this.$alert(
            '<div class="genLongImgDownLink"><a download="" href="' +
              response.data +
              '" target="_blank">点此链接下载长图</a></div><div class="genLongImgPreviewImg"><img class="genLongPreviewImg" src="' +
              response.data +
              '" ></div>',
            "长图下载",
            {
              dangerouslyUseHTMLString: true,
              showClose: false,
              confirmButtonText: "关闭",
              lockScroll: true,
              customClass: "genLongImg"
            }
          );
        })
        .catch(error => {
          this.loadingService.close();

          console.log(error);
          this.$message.error("文章生成长图时发生错误: " + error);
        });
    },
    convertItemToImage() {
      this.deactiveItem(this.getEditorDoc());

      this.loadingService = this.$loading({
        lock: true,
        text: "正在将样式转换成图片，请耐心等待",
        spinner: "el-icon-loading",
        // background: "rgba(0, 0, 0, 0.7)",
        target: document.querySelector("#editorAndAdvPanel")
      });

      let styleItemParent = this.selectedStyleItemParent;
      let bodyHtml =
        '<!DOCTYPE html><html><head><title>test</title><meta http-equiv="X-UA-Compatible" content="IE=edge,chrome=1"><meta http-equiv="content-type" content="text/html;charset=utf-8"><link rel="stylesheet" type="text/css" href="' +
        host +
        '/tinymce/editor.css"></head><body>' +
        styleItemParent.innerHTML +
        "</body></html>";
      //console.log(bodyHtml);
      let md5 = crypto.createHash("md5");
      md5.update(bodyHtml);
      let bodyHtmlHash = md5.digest("hex");
      let imageHost = host;
      //console.log(bodyHtmlHash);

      let headers = {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
        }
      };

      // let params = new URLSearchParams();
      // params.append("html", escape(bodyHtml));
      // params.append("hash", escape(bodyHtmlHash));
      let params = JSON.stringify({
        html: escape(bodyHtml),
        hash: escape(bodyHtmlHash),
        imageHost: escape(imageHost)
      });

      axios
        //.get(this.getGenImageAPI(this.importUrl))
        .post(this.getGenImageAPI(), params, headers)
        .then(response => {
          //console.log(response.data);
          //tinymce.activeEditor.setContent(response.data);

          this.loadingService.close();

          styleItemParent.innerHTML = '<img src="' + response.data + '">';

          this.setDirty();
        })
        .catch(error => {
          this.loadingService.close();

          console.log(error);
          this.$message.error("样式生成图片发生错误: " + error);
        });
    },
    getEditorDoc() {
      return tinymce.activeEditor.getDoc();
    },
    closeWindow() {
      window.onbeforeunload = () => {
        // await this.saveArticels();
        if (this.isSaveState) {
          return "离开此页面可能丢失文集内容，请确保文集已保存";
        }
      };
    },
    ListenerKeyDown() {
      document.addEventListener("keydown", async e => {
        if (
          e.keyCode === 83 &&
          (navigator.platform.match("Mac") ? e.metaKey : e.ctrlKey)
        ) {
          e.preventDefault();
          await this.saveArticels();
        }
      });
    },
    async saveArticels(saveType = 1) {
      findWords.closeAllHighlight();
      this.editorChanged();
      let type = true;
      this.setSaveLoading(type);

      if (this.getTitle === "") {
        if (saveType === 1) {
          this.$message({
            message: "标题不能为空",
            showClose: true,
            type: "error"
          });
          return;
        }
      }
      const getArticle = localStorage.getItem("lastEditorContent");
      if (getArticle) {
        this.insertDoc = JSON.parse(getArticle);
        if (this.insertDoc.title === "") {
          this.setSaveState(type);
          if (saveType === 1) {
            this.$message({
              message: "标题不能为空",
              showClose: true,
              type: "error"
            });
            return;
          }
        }
        let getTxt = tinymce.activeEditor.getBody().innerText;
        // if (getTxt.length <= 0) {
        //   this.setSaveState(type);
        //   return;
        // }
        this.insertDoc.intro = getTxt.substring(0, 100).replace(/\s*/gi, "");
        this.insertDoc.folderId = this.folderId;
        // if (this.getSessionDocId() !== 0 && this.getSessionDocId() !== "")
        this.insertDoc.docId = this.getSessionDocId();
        this.insertDoc.title = this.getTitle === "" ? "无标题" : this.getTitle;
        this.insertDoc.content = this.clearClass(
          tinymce.activeEditor.getBody().innerHTML
        );
        let result = await this.ADocInsert(this.insertDoc);
        if (result.errorCode === 0) {
          this.setSaveState(type);
          this.docUpdate = true;
          this.insertDoc.docId = result.data;
          this.setSessionDocId(result.data);
          this.setLastEditContent(this.insertDoc);
          if (saveType === 1) {
            this.$message({
              dangerouslyUseHTMLString: true,
              message: `文章已成功保存，可点击 <a href="/folder" target="_blank">“文集管理”</a> 菜单查看`,
              showClose: true,
              iconClass: "no"
            });
          }
        } else {
          if (result.errorCode === 300000) {
            this.insertConfig.showLoginMessage(
              true,
              "您当前账号暂未登录，请登录账号享更多权限",
              "save"
            );
          } else if (result.errorCode === 2008141157) {
            this.docUpdate = true;
            if (saveType === 1) {
              this.$message({
                dangerouslyUseHTMLString: true,
                message: `该文章无法保存，当前文章已经在文集中被删除，您可以在<a href="/recycle" target="_blank">“回收站”</a>找到`,
                showClose: true,
                iconClass: "no"
              });
            }
          } else if (result.errorCode === 2006191448) {
            this.insertDoc.docId = "";
            let result = await this.ADocInsert(this.insertDoc);
            if (result.errorCode === 0) {
              this.setSaveState(type);
              this.docUpdate = true;
              this.insertDoc.docId = result.data;
              this.setSessionDocId(result.data);
              this.setLastEditContent(this.insertDoc);
              if (saveType === 1) {
                this.$message({
                  dangerouslyUseHTMLString: true,
                  message: `文章已成功保存，可点击 <a href="/folder" target="_blank">“文集管理”</a> 菜单查看`,
                  showClose: true,
                  iconClass: "no"
                });
              }
            } else {
              this.$message({
                showClose: true,
                message: result.errorMess,
                type: "error"
              });
            }
          } else {
            this.$message({
              showClose: true,
              message: result.errorMess,
              type: "error"
            });
          }
        }
      }
    }
    // checkSingular(text) {
    //   if (!this.wycShow) {
    //     // let getDom = tinymce.activeEditor.getBody();
    //     // let getNode = getDom.getElementsByTagName("p");
    //     // for (let i = 0; i < getNode.length; i++) {
    //     //   if (getNode[i].innerText.indexOf(text) !== -1) {
    //     //     let dom = tinymce.activeEditor.selection.select(
    //     //       tinymce.activeEditor.dom.select("p")[i]
    //     //     );
    //     //     console.log(dom);
    //     //     let reg = new RegExp(
    //     //       '<span class="flicker"[^>]*?>' + text + "<\\/span>",
    //     //       "gi"
    //     //     );
    //     //     console.log(reg);
    //     //     let strdom = dom.innerHTML.replace(reg, text);
    //     //     tinymce.activeEditor.insertContent(strdom);
    //     //   }
    //     // }
    //
    //   }
    // }
  },
  async beforeDestroy() {
    await this.saveArticels();
  },

  watch: {
    myValue(newValue) {
      this.$emit("input", newValue);
    },
    saveState(newValue) {
      if (newValue) {
        this.oldContent = tinymce.activeEditor.getBody().innerHTML;
      }
    },
    wycShow(val) {
      if (!val) {
        if (val || !val) {
          this.editorWidth = document.getElementsByClassName(
            "tinymce-editor"
          )[0].offsetWidth;
          let mbtn = document.getElementById("menuBtn");
          if (this.contentWidth < 1435)
            mbtn.style.marginLeft = this.editorWidth - 30 + "px";
          else mbtn.style.marginLeft = this.editorWidth - 10 + "px";
          // mbtn.style.marginLeft = this.editorWidth - 10 + "px";
        }
      }
    },
    openNewWycNum: {
      handler() {
        const getShowTip = localStorage.getItem("wycShowTip");
        if (getShowTip) {
          if (JSON.parse(getShowTip).checkType) {
            this.$refs.wyclistbtn.showWycBox(true);
          }
        }
      }
    },
    leftShow: {
      handler(val) {
        if (val || !val) {
          this.editorWidth = document.getElementsByClassName(
            "tinymce-editor"
          )[0].offsetWidth;
          let mbtn = document.getElementById("menuBtn");
          if (this.contentWidth < 1435)
            mbtn.style.marginLeft = this.editorWidth - 30 + "px";
          else mbtn.style.marginLeft = this.editorWidth - 10 + "px";
          // mbtn.style.marginLeft = this.editorWidth - 10 + "px";
        }
      }
    },
    rightShow: {
      handler(val) {
        if (val || !val) {
          this.editorWidth = document.getElementsByClassName(
            "tinymce-editor"
          )[0].offsetWidth;
          let mbtn = document.getElementById("menuBtn");
          if (this.contentWidth < 1435)
            mbtn.style.marginLeft = this.editorWidth - 30 + "px";
          else mbtn.style.marginLeft = this.editorWidth - 10 + "px";
          // mbtn.style.marginLeft = this.editorWidth - 10 + "px";
        }
      }
    },
    insertHtml: {
      //deep: true,
      handler(val) {
        //console.log("给编辑器赋值");
        // console.log(this.insertHtml);
        // let newHtml =
        //   //margin: 0px auto; width: 100%; 让样式居中
        //   "<section class='parentStyle' style='margin: 0px auto; width: 100%;'><p style='display: block;'/>" +
        //   this.insertHtml +
        //   "<p style='display: block;'/></section><br />&nbsp;";

        //console.log(newHtml);

        this.deactiveItem(this.getEditorDoc());
        //tinymce.activeEditor.execCommand("mceInsertContent", false, newHtml);
        let content = val;
        content = content.replace(/<section[^>]*?>/gi, "<p>");
        content = content.replace(/<\/section>/gi, "</p>");
        content = content.replace(/<(?!p).*?>/gi, "");
        content = content.replace(/<p>(?:\s*&nbsp;\s*)*?<\/p>/gi, "");
        content = content.replace(/<p[^>]*?>/gi, "<p>");
        content = content.replace(
          content,
          '<p><span class="flicker">' + content + "</span></p>"
        );
        tinymce.activeEditor.insertContent(content);
        tinymce.activeEditor.focus();

        setTimeout(() => {
          let getDom = tinymce.activeEditor.getBody();
          let getNode = getDom.getElementsByTagName("p");

          let words_exp = val.replace(/([.[*?+^$|()/]|\\]|\\)/g, "\\$1");
          words_exp = words_exp.split(" ").join("\\s*");

          for (let i = 0; i < getNode.length; i++) {
            if (new RegExp(words_exp).exec(getNode[i].innerText) != null) {
              let dom = tinymce.activeEditor.selection.select(
                tinymce.activeEditor.dom.select("p")[i]
              );
              tinymce.activeEditor.insertContent(dom.innerText);
            }
            // if (getNode[i].innerText.indexOf(val) !== -1) {
            //   let dom = tinymce.activeEditor.selection.select(
            //     tinymce.activeEditor.dom.select("p")[i]
            //   );
            //   tinymce.activeEditor.insertContent(dom.innerText);
            // }
          }
        }, 1000);
      }
    },
    getTitle: {
      handler: function() {
        this.titleChanged();
      }
    },
    allContent: {
      handler: function(val) {
        // val = val.replace(/<section[^>]*?>/gi, "<p>");
        // val = val.replace(/<\/section>/gi, "</p>");
        // val = val.replace(/<(?!p).*?>/gi, "");
        // val = val.replace(/<p>(?:\s*&nbsp;\s*)*?<\/p>/gi, "");
        // val = val.replace(/<p[^>]*?>/gi, "<p>");
        if (val) {
          tinymce.activeEditor.setContent(val);
          tinymce.activeEditor.focus();
        }
      },
      deep: true
    },
    isSaveNum: {
      handler(val) {
        if (val) {
          // console.log(this.isSaveLength);
          this.genLongImage(this.isSaveLength);
        }
      }
    }
  }
};
</script>
<style lang="less" scoped>
@import "../../assets/style/mixin";
@import "../../assets/style/color";

.app-course1122 {
  color: #216bed;
  position: absolute;
  top: 8px;
  right: 0px;
  font-size: 14px;
  line-height: 16px;
  margin-right: 0px;
  background-color: #e0e6f6;
  padding: 5px 5px;
  border-radius: 30px 0px 0px 30px;
  text-indent: 5px;
}
.app-course1122 .app-course {
  color: #216bed;
  font-size: 14px;
  line-height: 16px;
  float: right;
  margin-right: 0px;
}

.mytoolbar {
  margin-top: -60px;
  background-color: rgb(245, 248, 255);
  position: fixed;
  z-index: 1900;
  width: 100%;
  height: 50px;
  margin-left: -20px;
  max-width: 850px;
}
/deep/.el-loading-spinner {
  top: 350px;
}

/deep/.cut_longimg_loading {
  width: 110%;
}

.button.el-button.is-round {
  padding: 5px 8px;
  border: 1px solid #dcdfe6 !important;
}
.button.el-button.is-round:hover {
  color: @blue;
  border-color: #c6e2ff;
  background-color: #ecf5ff;
}

.changeStyleMain {
  width: 400px;
  background-color: #fff;
  position: absolute;
  margin-left: 300px;
  font-size: 12px;
  z-index: 1000;
  .ml3 {
    margin-left: -4px;
  }
  .ml5 {
    margin-left: 5px;
  }
  .SliderWords {
    margin: 10px 0 0 0;
  }
  .dashed {
    width: 100%;
    margin-top: 12px;
  }
  .inputPercent {
    width: 35px;
    margin-top: 10px;
    border: 1px solid #e6e6e6;
    text-align: center;
  }
  .progressBox {
    margin-left: 5px;
    margin-top: -4px;
    .el-button--text {
      color: #a3aeb9;
    }
    .el-button {
      font-size: 18px;
      padding-bottom: 0px;
    }
  }

  /deep/.el-color-picker__trigger {
    padding: 2px;
    height: 18px;
    width: 18px;
  }
  /deep/.el-slider__bar {
    height: 3px;
  }
  /deep/.el-slider__runway {
    height: 3px;
  }
  /deep/.el-slider__button {
    width: 12px;
    height: 12px;
    border: 1px solid #d4d4d4;
    margin-top: -3px;
  }
  /deep/.el-color-picker__trigger {
    border-radius: 50%;
    .el-color-picker__color {
      border-radius: 50%;
      .el-color-picker__color-inner {
        border-radius: 50%;
      }
    }
  }
  /deep/.el-slider__runway {
    margin-bottom: 0px;
  }
}
.myAlpha {
  width: 100px;
  margin-top: 3px;
  /deep/.el-input__inner {
    font-size: 12px !important;
    font-weight: 400 !important;
    border: 1px solid #dcdfe6 !important;
    width: 100% !important;
    margin-left: 0px;
    padding-left: 20px !important;
    padding-right: 27px !important;
  }
  /deep/.el-input-number__decrease {
    margin-left: 0px;
  }
  /deep/.el-input {
    margin-left: 0 !important;
  }
}
.setPercent {
  position: absolute;
  margin-top: -23px;
  margin-left: 56px;
  z-index: 10;
}
.setPercent2 {
  position: absolute;
  margin-top: -23px;
  margin-left: 54px;
  z-index: 10;
}
.myWidth {
  width: 100px;
  margin-top: 3px;
  margin-left: -2px;
  /deep/.el-input__inner {
    font-size: 12px !important;
    font-weight: 400 !important;
    border: 1px solid #dcdfe6 !important;
    width: 100% !important;
    margin-left: 0px;
    padding-left: 20px !important;
    padding-right: 27px !important;
  }
  /deep/.el-input-number__decrease {
    margin-left: 0px;
  }
  /deep/.el-input {
    margin-left: 0 !important;
  }
}
.wordsCount {
  font-size: 12px;
  margin-top: -30px;
  float: right;
  margin-right: 60px;
  color: #999;
}
.hr {
  border: 0;
  border-top: 1px solid #eee;
  margin: 20px 50px;
  color: #d4d6da;
}
.tinymce-editor {
  min-width: 460px;
  max-width: 820px;
  width: 100%;
  margin: 0 auto;
  background-color: #fff;
  /*min-height: 460px;*/
  min-height: calc(100vh - 60px);
  box-shadow: #d9e5fb 0px 0px 8px 1px;
  margin-top: 100px;
  margin-bottom: 40px;
  // top: 62px;
  .input {
    padding: 60px 60px 0 60px;
    .red {
      color: red;
    }
    div {
      &:nth-child(2) {
        font-size: 13px;
        margin-top: 10px;
      }
    }
  }
}
/deep/.el-input {
  margin-left: -15px;
  .el-input__inner {
    width: 95%;
    font-size: 24px;
    font-weight: 900;
    border: 0;
    /*border-bottom: 1px solid #c5c5c5;*/
    border-radius: 0;
    color: #333;
  }
}
.listBtnMain {
  padding: 5px 10px;
  position: fixed;
  top: 26%;
}
.listbutton {
  .listBtnMain();
  margin-left: 810px;
}
.listbutton1 {
  .listBtnMain();
  margin-left: 790px;
}
.listbutton2 {
  .listBtnMain();
  margin-left: 780px;
}
.listbutton3 {
  .listBtnMain();
  margin-left: 720px;
}
.listbutton4 {
  .listBtnMain();
  margin-left: 750px;
}
/deep/.mce-content-body {
  background-color: #fff;
  padding: 0 50px 20px 50px;
  border: 0;
  margin-top: 40px;
  -webkit-box-shadow: none;
  min-height: calc(100vh - 180px);
  /*max-height: calc(100vh + 1000px);*/
  overflow: hidden;
  line-height: 1.8;
  font-family: 微软雅黑;
  font-size: 16px;
  p {
    font-family: 微软雅黑;
    font-size: 16px;
  }
  .mce-resizehandle {
    background-color: #fff;
    border: 1px solid black;
    width: 7px;
    height: 7px;
  }
  /deep/.mce-resizehandle {
    z-index: 10;
  }
  ._5118editor {
  }
  .n_active {
    z-index: 100;
    outline: 1.5px dashed red !important;
    outline-offset: 2px;
  }
  /deep/ img {
    max-width: 100% !important;
    height: auto !important;
  }

  /deep/ section {
    max-width: 100% !important;
  }
  /deep/ iframe {
    /* max-width: 96% !important;
    height: auto; */
    border: 0;
    background-color: transparent;
  }
  /deep/ blockquote {
    margin: 0;
    padding-left: 10px;
    border-left: 3px solid #dbdbdb;
  }

  .icon_emotion_single {
    width: 20px;
    height: 20px;
    vertical-align: middle;
    display: inline-block;
    -webkit-background-size: 20px auto;
    background-size: 20px auto;
  }

  .weapp_image_link {
    font-size: 0;
    display: inline-block;
    position: relative;
  }

  .weapp_image_link:after {
    content: " ";
    width: 26px;
    height: 26px;
    display: block;
    position: absolute;
    top: 9px;
    right: 9px;
    background: url(data:image/png;base64,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)
      no-repeat center;
    background-size: contain;
  }

  .weapp_image_link.notag:after {
    display: none;
  }

  .h5_image_link {
    font-size: 0;
    display: inline-block;
    position: relative;
  }

  .h5_image_link:after {
    content: " ";
    width: 26px;
    height: 26px;
    display: block;
    position: absolute;
    top: 9px;
    right: 9px;
    background: url(data:image/png;base64,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)
      no-repeat center;
    background-size: contain;
  }

  .h5_image_link.notag:after {
    display: none;
  }

  .h5_image_link:after {
    background: url(data:image/png;base64,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)
      no-repeat center;
    background-size: contain;
  }

  .vote_area {
    display: block;
  }

  .vote_iframe {
    height: 100%;
    width: 100% !important;
    *width: 96% !important;
  }

  .qqmusic_iframe {
    width: 100% !important;
    height: 75px;
  }

  .audio_iframe {
    width: 100% !important;
    height: 82px;
  }

  .video_iframe {
    background-color: #000;
    width: 100% !important;
    *width: 96% !important;
    position: static;
    min-height: 375px;
  }

  .shopcard_iframe {
    width: 100% !important;
    height: 95px;
    margin: 14px 0;
  }

  .topic_iframe {
    width: 100% !important;
    height: 118px;
    margin: 14px 0;
  }

  .weapp_app_iframe {
    height: 330px;
    margin: 14px 0;
  }

  .weapp_text_link {
    font-size: 17px;
  }

  .weapp_text_link:before {
    content: "";
    display: inline-block;
    line-height: 1;
    background-size: 12px 12px;
    background-repeat: no-repeat;
    background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAMAAABF0y+mAAAAb1BMVEUAAAB4it11h9x2h9x2h9x2htx8j+R8i+B1h9x2h9x3h92Snv91htt2h9x1h9x4h9x1h9x1h9x2idx1h9t2h9t1htt1h9x1h9x1htx2h9x1h912h9x4h913iN17juOOjuN1iNx2h9t4h958i+B1htvejBiPAAAAJHRSTlMALPLcxKcVEOXXUgXtspU498sx69DPu5+Yc2JeRDwbCYuIRiGBtoolAAAA3ElEQVQoz62S1xKDIBBFWYiFYImm2DWF///G7DJEROOb58U79zi4O8iOo8zuCRfV8EdFgbYE49qFQs8ksJInajOA1wWfYvLcGSueU/oUGBtPpti09uNS68KTMcrQ5jce4kmN/HKn9XVPAo702JEdx9hTUrWUqVrI3KwUmM1NhIWMKdwiGvpGMWZOAj1PZuzAxHwhVSplrajoseBnbyDHAwvrtvKKhdqTtFBkL8wO5ijcsS3G1JMNvQ5mdW7fc0x0+ZcnlJlZiflAomdEyFaM7qeK2JahEjy5ZyU7jC/q/Rz/DgqEuAAAAABJRU5ErkJggg==");
    vertical-align: middle;
    font-size: 11px;
    color: #888;
    border-radius: 10px;
    background-color: #f4f4f4;
    margin-right: 6px;
    margin-top: -4px;
    background-position: center;
    height: 20px;
    width: 20px;
  }

  .cpc_iframe {
    width: 100% !important;
    height: 378px;
    margin: 14px 0;
    z-index: 9999;
    position: relative;
  }

  .section-product {
    width: 106.6% !important;
    width: -webkit-calc(100% + 34px) !important;
    width: calc(100% + 34px) !important;
    margin-left: -17px;
  }

  .product-recommended {
    position: relative;
    z-index: 1;
    margin-bottom: -32px;
    margin-top: 20px;
  }

  .product-recommended__badge {
    height: 32px;
    background-color: #1aad19;
    display: inline-block;
    border-radius: 0 0 10px 10px;
    font-size: 14px;
    color: #fff;
    line-height: 32px;
    padding: 0 16px;
  }

  .product-recommended__icon {
    display: inline-block;
    vertical-align: -2px;
    background: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAARCAYAAAAougcOAAAABGdBTUEAALGPC/xhBQAAA+ZJREFUOBGNVGtM01cU//XJoy0DJiAPGRWGk+gk0aAIgpLMOO0mH7aMJXNbskm2RMfclmzNlumHsQ/GZEuG7pPxAX5wi9NlaIbMSUcJmOELt/AsBKcOCoWupVLW0us9R7lhWsPOP70995xz77nnnN85moxT6QILkFFrxKyY5d8CplHV2qjSB0K6fIf1dTRVnMcPZaeRbcpW5qT7v6R/nGF5Wjk+XP4RVievViYfF3yCms73YF9hx3OLN6PX3wvHqAOXxjvgmnIhIiLKdj7ziJM8Sx7ef2YPtmdth0ajwb6uvQiEA/hiVS3i9fEg/TtPv8t35FpysTVjK4KzQfT4euB0O9E69hu6JrvgC/mUH81cTRKNidiZtxNv5b4Ni8HCBjcDN1HctI555+Y2fNt3CAaZptrCWozPjOPiyK8okxGnxaapC4m5M30HnZ5ONN5uxLnbZwFyUt1RLVx+lyCaCk3xPy3hSFjUDx4XhwcOi4mZCVHStF5cGLnAevtVu6CzNZ01yp4YmbL/7F91VgntsoRlOFh0EEvNS2G/ZsfG5nK0jTn5ZTqNDq9Zd2DtorV4seUF3A3fxZrkNawrerIIdLZ4UTHvaen398N20Ya9XZ8rJCYZk3C/JkIgIr+ef7o51NGgWx0k5sbkDQxODWJbpg0JhgTWVS6plPttMn0GZdvn68W1yavwyFR+uuIzrhWljdPVMNTAId4K3BISLaLf1y9kPVTYwXBQbDhfKo65jipZNIbsvh/+TlzxXGZ1+1i7yDyVITiSr7u/wpb0LciMzwSlqOKXTYjRxeDniiYuqjfk5VSVpJTyqwlJoUgIKxNXqiiIoTMvZb+sZA63A0J+3IyEhkMSOURhEUacPg5mvRkmvYllbWNtSDYmw2q2YmR6BJWOSthabBjwD7A+2kI90+puZZXq+ONDxyTWu5EVn8URNJSckI3WgtHgKBuvTymBVqNFrC4WVlMOckxPqUfQTQ1D9Xiz/Q0uPu0J/lRjIuWEkLP/z/0cXkpMCn786wyqL1VzM0bk3Joj6qfT5WdwdtM5pMels5hefcR1BM1/N/MEIGGHnALTs9Os11lesexjTi6EoFVJz0o458qO9eO69zqelx1NKDrQfYBhaTGYkSqbj/I/RzQZ8mT3Z5mWoCqniidDXV8dCG1EquPnDhQ8UYCfNjZyWsKyuHoJ0SsTl7Hr910YDgyDBmN+Qj4ofWWpZShMKgT1wnyirGxoLuX6kfwRJyTcs/wD7M7fDfeMG3W93+Dk8ElGE+keJhopNERpoK6TjZkam4p6WZ8v/6hVplGdkJaGn2fGA++/XmW8EEOgoJoRAufTPdNw+5MNn+J7AAAAAElFTkSuQmCC")
      0 0 no-repeat;
    width: 25px;
    height: 16px;
    -webkit-background-size: cover;
    background-size: cover;
    margin-right: 5px;
  }

  img[data-mce-selected] {
    outline: 1px solid black;
    /*outline: 0;*/
    resize: none;
  }
  table {
    border: 1px solid;
    td {
      border: 1px solid;
    }
  }
  hr {
    margin-top: 20px;
    margin-bottom: 20px;
    border: 0;
    border-top: 1px solid #eee;
  }
  li {
    list-style: initial !important;
    list-style-type: unset !important;
  }
  ol {
    list-style-type: decimal;
  }
  ul {
    list-style: disc;
  }

  [data-highlight="error"] {
    /*display: inline-block;*/
    background: #fe807d;
    color: rgb(255, 255, 255);
  }
  [data-highlight="getPro"] {
    /*display: inline-block;*/
    background: #fe2020;
    color: rgb(255, 255, 255);
  }
  [data-highlight="ori1"] {
    /*display: inline-block;*/
    background: #f56c6c;
    color: rgb(255, 255, 255);
  }
  [data-highlight="ori2"] {
    /*display: inline-block;*/
    background: #e6a23c;
    color: rgb(255, 255, 255);
  }
  [data-highlight="ori3"] {
    /*display: inline-block;*/
    background: #67c23a;
    color: rgb(255, 255, 255);
  }

  p {
    padding: 0;
    margin: 0;
    letter-spacing: 0.3px;
    /*line-height: 1.75em;*/
    /*margin-bottom: 16px;*/
    /*margin-top: 16px;*/
    .proBackColor {
      background-color: #fe807d;
    }
    .errBackColor {
      background-color: #fe908b;
    }
    .oriBackColor1 {
      background-color: #f56c6c;
    }
    .oriBackColor2 {
      background-color: #e6a23c;
    }
    .oriBackColor3 {
      background-color: #67c23a;
    }

    .flicker {
      background-color: #d7e3f6;
      animation-iteration-count: 3;
      animation: twinkle 0.3s infinite alternate;
      -webkit-animation-iteration-count: 3;
    }
    @keyframes twinkle {
      0% {
        opacity: 0.8;
      }
      100% {
        opacity: 0;
      }
    }
    &::selection {
      background-color: #d7e3f6;
    }
  }
}
.links {
    padding-top: 20px;
    color: black !important;
    font-size: 12px;
    text-align: left;
    line-height: 24px;
}
.links .link-item{
     color:black !important;
    display: inline-block;
    margin-right: 13px;
}
</style>
<style lang="less">
@import "../../assets/style/color";
.tox {
  .tox-dialog-inline {
    right: 25%;
  }
}
.genLongPreviewImg {
  width: 400px !important;
}

.genLongImg {
  width: 460px !important;
}

.genLongImgPreviewImg {
  width: 430px;
  max-height: 500px;
  overflow: visible;
  overflow-x: hidden;
  border: 1px solid #ededed;
}

.genLongImgDownLink {
  text-align: center;
  padding-bottom: 10px;
  font-size: 16px;
}
</style>
